module.exports = __webpack_public_path__ + "components/flag/static/square/na-6c42196bb884071e550b3ba0f361e8f6.svg";